import React from 'react';
import PropTypes from 'prop-types';
import { Image as CLDImage, Transformation, CloudinaryContext } from 'cloudinary-react';

import { getCloudinaryURL } from 'utils/media';

import config from '../../config/config.json';
import ImageTag from '../ImageTag';

const ImageTransformation = props => {
  const { alt, src, placeholder, className, transformation, lazyload, cloudinary = true, isSSRElgible = false } = props;

  const onImageLoadFailure = event => {
    const { target } = event;
    target.src = placeholder;
    target.onError = null;
  };

  if (!src) {
    return (
      <>
        <ImageTag alt={alt} src={placeholder} className={className} />
      </>
    );
  }

  if (isSSRElgible && config.CLOUDINARY_CLOUD_ID) {
    const cloudinaryUrl = getCloudinaryURL({ src, transformation });

    if (!cloudinaryUrl) {
      return <></>;
    }

    return <ImageTag alt={alt} src={cloudinaryUrl?.fallback} className={className} isSSRElgible={isSSRElgible} />;
  }

  const imageContent = (
    <CLDImage publicId={src} alt={alt} type="fetch" className={className} onError={onImageLoadFailure}>
      {transformation && <Transformation fetchFormat="auto" {...transformation} />}
    </CLDImage>
  );

  const content =
    config.CLOUDINARY_CLOUD_ID && cloudinary !== false && typeof window !== 'undefined' ? (
      <CloudinaryContext cloudName={config.CLOUDINARY_CLOUD_ID} secure="true">
        {imageContent}
      </CloudinaryContext>
    ) : (
      <ImageTag alt={alt} src={src} lazyLoad={lazyload} className={className} onError={onImageLoadFailure} />
    );

  return content;
};
ImageTransformation.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  placeholder: PropTypes.any,
  className: PropTypes.string,
  transformation: PropTypes.object,
  lazyload: PropTypes.bool,
  cloudinary: PropTypes.bool,
};

ImageTransformation.defaultProps = {
  placeholder: '/images/placeholder.png',
  lazyload: false,
  cloudinary: true,
};

export default ImageTransformation;
